import { createSelector } from 'reselect';

const sliceGames = state => state.session.games;

const PREDICATES = {
  LEFT: p => p.position === 'left',
  HEROLEFT: p => p.you === true && p.position === 'left',
  DURATION: game => game.duration,
  LEVEL: p => p.level,
  PLAYERS: games => games.players,
  VICTORY: game => game.victory === true,
  RIVALS: p => p.team === false,
  TEAMMATE: p => p.team === true && !p.you,
  HERO: p => p.you === true,
  FLATTEN: (acc, it) => [...acc, ...it],
  TOTALDURATION: (acc, duration) => acc * 1 + duration * 1,
};

export const gameSelector = createSelector(sliceGames, games => {
  if (games.length === 0) {
    let response = {
      universe: 0,
    };
    return {
      ...response,
    };
  } else {
    let players = games.map(PREDICATES.PLAYERS).reduce(PREDICATES.FLATTEN, []);

    let response = {
      games,
      universe: games.length,
      victories: games.filter(PREDICATES.VICTORY),
      minutes: games
        .map(PREDICATES.DURATION)
        .reduce(PREDICATES.TOTALDURATION, 0),
      // players,
      victoriesLeft: getWinsLeft(games),
      left: getLeft(games),
      rivals: getRivals(players),
      teammate: getTeammates(players),
    };

    let last5 = sortBy(games, 'month').slice(-5);
    let [streakVictories, streakLosses] = chunkPredicate(
      last5,
      PREDICATES.VICTORY,
    );

    let streak = {
      streakWins: (streakVictories.length / last5.length) * 100,
      // streakLosses: (streakLosses.length / last5.length) * 100,
    };

    return {
      ...response,
      ...streak,
    };
  }
});
function getWinsLeft(games) {
  const wins = games.filter(PREDICATES.VICTORY);
  return wins.filter(w => w.courtSide === 'left');
}

function getLeft(games) {
  return games.filter(g => g.courtSide === 'left').length;
}

function getRivals(players) {
  let [rivals, rest] = chunkPredicate(players, PREDICATES.RIVALS);
  let levels = rivals.map(PREDICATES.LEVEL);
  return frecuency(levels);
}

function getTeammates(players) {
  let [teammate, rest] = chunkPredicate(players, PREDICATES.TEAMMATE);
  let levels = teammate.map(PREDICATES.LEVEL);
  return frecuency(levels);
}

function sortBy(arr, k, isAsc = true) {
  if (!k) return arr;
  const sorted = arr.sort((a, b) => {
    return (a[k] < b[k] ? -1 : 1) * (isAsc ? 1 : -1);
  });
  return sorted;
}

function chunkPredicate(arr, predicate) {
  let match = [];
  let dispose = [];

  for (const el of arr) {
    if (predicate(el) === true) {
      match.push(el);
    } else {
      dispose.push(el);
    }
  }
  return [match, dispose];
}
function frecuency(arr) {
  let bag = {};
  arr.forEach(item => {
    bag[item] = bag[item] ? ++bag[item] : 1;
  });
  return bag;
}
